import { http } from '@/shared/api/http';
import type { DeepRequired, Schema } from '@/shared/api';

// 08.08.2026 бэк развернул sql.Null*-обёртки: TITLE/DESCRIPTION/CREATED_BY/
// RESPONSIBLE_ID/GROUP_ID/DEADLINE_AFTER приходят плоскими (null → "" / 0).
// Вызовы textOf/intOf у потребителей оставлены — они пропускают примитивы как есть.
export type TaskTemplate = DeepRequired<
  Schema<'tasks_module_internal_models.TaskTemplate'>
>;

export async function fetchTaskTemplates(): Promise<TaskTemplate[]> {
  const r = await http.get<{ result: TaskTemplate[] }>('/tasks/templates');
  return Array.isArray(r.data?.result) ? r.data.result : [];
}

/**
 * Докачать вложение шаблона по id. FILES у шаблона — это id файлов; байты
 * отдаёт authed-прокси GET /files/{id}/raw (кука, same-origin), имя — из
 * Content-Disposition. Возвращаем File, готовый лечь в attachedFiles формы.
 */
export async function fetchTemplateFile(id: number): Promise<File> {
  const res = await http.get(`/files/${id}/raw`, { responseType: 'blob' });
  const blob = res.data as Blob;
  const cd = String(res.headers['content-disposition'] ?? '');
  const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(cd);
  const plain = /filename="?([^"]+)"?/i.exec(cd);
  const name = utf8
    ? decodeURIComponent(utf8[1])
    : plain
      ? plain[1]
      : `attachment-${id}`;
  return new File([blob], name, {
    type: blob.type || 'application/octet-stream',
  });
}
